import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function Edit() {
    const navigate = useNavigate();

    const { ID } = useParams();
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [location_name, setLocation_name] = useState("");

    const [validationError, setValidationError] = useState({});

    useEffect(() => {
        fetchBranch();
    }, []);

    const fetchBranch = async () => {
        await axios
            .get(
                `${process.env.REACT_APP_API}/location/APILimited/${ID}`
            )
            .then(({ data }) => {
                const { latitude } = data[0];
                const { longitude } = data[0];
                const { location_name } = data[0];

                setLatitude(latitude);
                setLongitude(longitude);
                setLocation_name(location_name);
            })
            .catch(({ response: { data } }) => {
                Swal.fire({
                    text: data.message,
                    icon: "error",
                });
            });
    };

    const updateDepartment = async (e) => {
        e.preventDefault();

        await axios
            .post(
                `${process.env.REACT_APP_API}/location/APILimited/${ID}`,
                {
                    latitude: latitude,
                    longitude: longitude,
                    location_name: location_name,
                }
            )
            .then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    timer: 1500,
                    text: data.message,
                });
                navigate("/managelocation");
            })
            .catch(({ response }) => {
                if (response.status === 422) {
                    setValidationError(response.data.errors);
                } else {
                    Swal.fire({
                        text: response.data.message,
                        icon: "error",
                    });
                }
            });
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-sm-12 col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Update Location</h4>
                            <hr />
                            <div className="form-wrapper">
                                {Object.keys(validationError).length > 0 && (
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="alert alert-danger">
                                                <ul className="mb-0">
                                                    {Object.entries(
                                                        validationError
                                                    ).map(([key, value]) => (
                                                        <li key={key}>
                                                            {value}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <Form onSubmit={updateDepartment}>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="latitude">
                                                <Form.Label>
                                                Location
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={latitude}
                                                    onChange={(event) => {
                                                        setLatitude(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="longitude">
                                                <Form.Label>
                                                Location Details
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={longitude}
                                                    onChange={(event) => {
                                                        setLongitude(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group controlId="location_name">
                                                <Form.Label>
                                                Location Details
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={location_name}
                                                    onChange={(event) => {
                                                        setLocation_name(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group as={Row} className="mb-3 mt-3">
                                        <Col sm={{ span: 2, offset: 20 }}>
                                            <Button
                                                variant="secondary"
                                                type="submit"
                                            >
                                                <i class="fa fa-save"></i>  Update
                                            </Button>
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
